import { useMutation } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

type Check = { connected: boolean; message: string; checkedAt?: string; tools?: string[] };
export function MetaAiReportingStatus({ accountId, accountName }: { accountId: number; accountName: string }) {
  const check = useMutation<Check>({
    mutationFn: async () => {
      const response = await fetch(`/api/meta/mcp/accounts/${accountId}/check`, { method: 'POST', credentials: 'include' });
      if (!response.ok) throw new Error('The reporting connection could not be checked.');
      const result = await response.json();
      if (!result || typeof result.connected !== 'boolean' || typeof result.message !== 'string' || !result.message.trim()) throw new Error('Invalid reporting response');
      return result;
    },
  });
  return <section className="mt-3 rounded-lg border border-border bg-background p-3" aria-label={`AI reporting for ${accountName}`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div><p className="text-sm font-medium">Meta AI reporting</p><p className="text-xs text-muted-foreground">Ask about performance, trends and recommendations in chat.</p></div>
      <Button variant="outline" size="sm" onClick={() => check.mutate()} disabled={check.isPending}>
        {check.isPending && <Loader2 className="mr-2 h-3 w-3 animate-spin" />}Check connection
      </Button>
    </div>
    <p className="mt-2 text-xs text-muted-foreground">Sandbox verification · Reports only. Campaigns and budgets cannot be changed.</p>
    {(check.data || check.error) && <p role="status" className="mt-2 text-sm">{check.error ? 'The reporting connection could not be checked. Try again.' : check.data?.message}</p>}
    {check.data?.checkedAt && <p className="mt-1 text-xs text-muted-foreground">Checked {new Date(check.data.checkedAt).toLocaleString()}</p>}
  </section>;
}
